import { Divider, Stack, Typography } from '@mui/material';
import {
  BackupStatus,
  ConditionOperatorEnum,
  type InventoryResource,
} from '@repo/api-gw-sdk';

import ButtonWithIcon from '@/components/buttons/buttonWithIcon';
import { resourceId } from '@/components/queryBuilder/properties';
import { Icon } from '@/components/shared/icon';
import { NavigationLink } from '@/components/shared/link';
import { useRoles } from '@/contexts/useRoles';
import { createCombineCondition } from '@/types/advanceFilter';

const JobsLink = ({
  type,
  resource,
}: {
  type: 'backup' | 'restore' | 'classification';
  resource: InventoryResource;
}) => {
  const { isAuthorized } = useRoles();
  const condition = createCombineCondition([
    {
      operator: ConditionOperatorEnum.In,
      value: [resource.providerResourceId],
      property: resourceId.name,
    },
  ]);

  return (
    <NavigationLink
      disabled={!isAuthorized('read:jobs')}
      path={`/jobs/${type}`}
      searchParams={{ query: condition }}
    >
      <ButtonWithIcon
        text='View'
        iconPosition='right'
        variant='text'
        icon={<Icon iconClass='material-symbols-arrow-right-alt' />}
      />
    </NavigationLink>
  );
};

export const JobsSection = ({ resource }: { resource: InventoryResource }) => {
  return (
    <Stack className='w-full' gap='20px' divider={<Divider />}>
      {resource.backupStatus === BackupStatus.InitialClassification ? (
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          className='px-[40px]'
        >
          <Typography>Classification jobs</Typography>
          <JobsLink resource={resource} type='classification' />
        </Stack>
      ) : (
        <>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            className='px-[40px]'
          >
            <Typography>Backup jobs</Typography>
            <JobsLink resource={resource} type='backup' />
          </Stack>
          <Stack
            direction='row'
            alignItems='center'
            justifyContent='space-between'
            className='px-[40px]'
          >
            <Typography>Restore jobs</Typography>
            <JobsLink resource={resource} type='restore' />
          </Stack>
        </>
      )}
    </Stack>
  );
};
